import React from "react";
import Marquee from "react-fast-marquee";

const PARTNERS = [
    "Spotify",
    "Apple Music",
    "YouTube",
    "Tidal",
    "SoundCloud",
    "Amazon Music",
    "Deezer",
    "TikTok",
    "Instagram",
    "Audiomack",
    "Pandora",
    "Anghami",
];

export const TrustMarquee = () => {
    return (
        <section
            className="relative py-20 border-y border-white/5 bg-[#030023]"
            data-testid="trust-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <p
                    className="text-center text-sm uppercase tracking-[0.3em] text-white/45 mb-10 font-medium"
                    data-testid="trust-caption"
                >
                    Trusted by emerging and global creators
                </p>

                <div className="marquee-mask">
                    <Marquee gradient={false} speed={40} pauseOnHover>
                        {PARTNERS.map((p, i) => (
                            <div
                                key={i}
                                className="mx-10 flex items-center gap-3 group"
                                data-testid={`partner-${p.replace(/\s/g, "-")}`}
                            >
                                <span className="w-2 h-2 rounded-full bg-[#791EE2] opacity-60 group-hover:opacity-100 transition" />
                                <span className="font-heading text-2xl md:text-3xl font-bold text-white/40 group-hover:text-white transition-colors whitespace-nowrap">
                                    {p}
                                </span>
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </section>
    );
};
